// A key for an uncontrolled (defaultValue) cell. It changes with the saved
// value, so the cell remounts and shows data from a refetch, e.g. after a
// group update. A pending item updates state on every keystroke, so its key
// stays put; remounting would lose the cursor mid-typing.
const refreshKey = (
  item: { id: string; type?: string; isPending?: boolean },
  value: unknown
): string =>
  item.isPending
    ? `${item.type}-${item.id}`
    : `${item.type}-${item.id}-${value ?? ""}`;

export default refreshKey;
